// extracted by mini-css-extract-plugin
export default {"dashboardLayout":"DashboardLayout_dashboardLayout__nV3Pu","mainContent":"DashboardLayout_mainContent__VBp1K","content":"DashboardLayout_content__N5rHE"};